import Model, { attr } from '@ember-data/model';

export default Model.extend({
  fileName: attr('string'), // desired file name. this needs to be set when creating an s3Upload

  key: attr('string'),
  bucket: attr('string'),
  accessKey: attr('string'),
  policy: attr('string'),
  signature: attr('string'),
});
